/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable react/jsx-no-undef */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/destructuring-assignment */
import { Group, Paper, Space } from '@mantine/core';
import PageSection from '../../../../../../../components/core/PageSection/PageSection';
import { EventEquipmentType, EventType } from '../../../../../../../models/core/events.type';
import { Feature } from '../../../../../../../utils/constants.utils';
import EventEquipmentItem from './EventEquipmentItem';
import EventEquipmentQuotation from './EventEquipmentQuotation';

type DataViewProps = {
  data: EventEquipmentType;
  event: EventType;
};

export default function EventEquipmentView(props: DataViewProps) {
  return (
    <div>
      <Paper shadow="xs" p="md" withBorder>
        <PageSection
          size="lg"
          color={Feature.Home.Event.color}
          label="Equipamento"
          text="Detalhes do equipamento."
        />
        <Space h="xs" />
        <EventEquipmentItem data={props.data} />
      </Paper>
      <Space h="lg" />

      <Paper shadow="xs" p="md" withBorder>
        <Group justify="space-between">
          <PageSection
            size="lg"
            color={Feature.Home.Event.color}
            label="Fornecedor"
            text="Detalhes do fornecedor."
          />
        </Group>
        <Space h="xs" />
        <EventEquipmentQuotation
          data={props.data.cotacao}
          compra={props.event.referencia!.contrato.residuo!.compra}
        />
      </Paper>
    </div>
  );
}
